export const mainFontFamily = '"Spyscape Two", "Helvetica", "Arial", sans-serif';
export const displayFontFamily = '"Spyscape Two Redacted", "Helvetica", "Arial", sans-serif';

/*
  Identify IE11 by media query
  https://www.mediacurrent.com/blog/pro-tip-how-write-conditional-css-ie10-and-11/
*/

export const onlyInternetExplorer = '(-ms-high-contrast: none), (-ms-high-contrast: active)';
export const mediaOnlyInternetExplorer = `@media all and ${onlyInternetExplorer}`;

/*
  Twitter Bootstrap Media queries
  https://getbootstrap.com/docs/4.3/layout/overview/#responsive-breakpoints
*/

export const mediaBreakpointUpSM = '@media (min-width: 576px)';
export const mediaBreakpointUpMD = '@media (min-width: 768px)';
export const mediaBreakpointUpLG = '@media (min-width: 992px)';
export const mediaBreakpointUpXL = '@media (min-width: 1200px)';

export const mediaBreakpointDownSM = '@media (max-width: 576px)';
export const mediaBreakpointDownMD = '@media (max-width: 768px)';
export const mediaBreakpointDownLG = '@media (max-width: 992px)';
export const mediaBreakpointDownXL = '@media (max-width: 1200px)';

/*
  Colours
  From the brand guidlines
  https://company-85016.frontify.com/d/XT7vzKUx5rql/digital#/color-palette/colors-1516381881
*/

export const ssColorBlack = '#000';
export const ssColorWhite = '#FFFFFF';
export const ssColorCyan = '#4EC3F7';
export const ssColorBlue = '#1B1F2C';
export const ssColorNavy = '#00031a';
export const ssColorDarkNavy = '#0C101C';
export const ssColorDarkGrey = '#3C3C3B';
export const ssColorMidGrey = '#A8A8A8';
export const ssColorLightGrey = '#ECECEC';
export const ssColorOffWhite = '#F3F3F3';
export const ssColorAlert = '#FF8366';
export const ssColorPositive = '#64DB31';
export const ssColorNegative = ssColorAlert;

/* Game colours */
export const ssColorSpecOps = '#B2FF59';
export const ssColorDeception = '#FF5353';
export const ssColorEncryption = '#9F92FD';
export const ssColorSurveillance = '#29D8D8';

/* Un-official colours */
export const ssColorUltraDarkGrey = '#111';
export const ssColorVeryDarkGrey = '#212121';
export const ssColorMidBlueGrey = '#A9B3CF';

/*
  Table Borders
*/

export const borderStyle = `2px solid ${ssColorWhite}`;

/*
 Vertical/Horizontal units
*/

export const horizontalSpacing = {
  value: '0.5',
  unit: 'rem',
};
export const verticalSpacing = {
  value: '0.5',
  unit: 'rem',
};

/*
 Nav height
*/

export const navHeightDefault = '50px';
export const navHeightWide = '60px';
export const navHeightWideWithSecondary = '100px';

/*
 Transitions
*/

export const transitionFast = '0.25s';
